import { render, staticRenderFns } from "./CustomerServiceOrder.vue?vue&type=template&id=1bc1cd22&scoped=true&"
import script from "./CustomerServiceOrder.vue?vue&type=script&lang=js&"
export * from "./CustomerServiceOrder.vue?vue&type=script&lang=js&"
import style0 from "./CustomerServiceOrder.vue?vue&type=style&index=0&id=1bc1cd22&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc1cd22",
  null
  
)

export default component.exports